export default () => {
  const elements = document.querySelectorAll('.parallax')
  if (elements.length < 1) return
  ;[...elements].forEach(element => {
    console.log(element)
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Parallax.js